import React, { useState } from "react";
import {
  ArrowBackIosRounded,
  ArrowForwardIosRounded,
} from "@material-ui/icons";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import PropTypes from "prop-types";

import GetWeatherIcon from "./GetWeatherIcon";
import GetRainIcon from "./GetRainIcon";
import { COLORS_PROJECT } from "../../../constants";

const useStyles = makeStyles((theme) => ({
  containerComponentDescription: {
    position: "absolute",
    width: "100%",
    backgroundColor: "#f5f5f5",
    display: "flex",
    flexDirection: "row-reverse",
    marginTop: "10px",
    borderRadius: "10px",
  },
  tableContainer: {
    margin: "0",
    borderRadius: "10px",
    height: "310px",
    backgroundColor: "white",
    overflowY: "hidden",
  },
  tableHead: {
    backgroundColor: "#f5f5f5",
    color: "#263C73",
  },
  tableCell: {
    padding: theme.spacing(1),
    justifyContent: "center",
    textAlign: "center",
    borderBottom: `1px solid #FDD835`,
    backgroundColor: COLORS_PROJECT.color_background_tables,
    color: "#263C73",
  },
  dayColumn: {
    fontWeight: 500,
    textAlign: "center",
    backgroundColor: COLORS_PROJECT.color_background_tables,
    borderBottom: `1px solid #FDD835`,
    color: "#263C73",
  },
  forecastRow: {
    backgroundColor: "#FDD835",
    borderBottom: "1px solid #ddd",
    
  },
  forecastIcon: {
    display: "flex",
    justifyContent: "center",
  },
  pagination: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    padding: theme.spacing(2),
    backgroundColor: COLORS_PROJECT.color_background_tables,
    borderRadius: "10px",
  },
  arrowButton: {
    margin: 0,
    padding: 0,
  },
  arrowContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    display: "flex",
    flexDirection: "column",
  },
  temperatureBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  current: {
    fontSize: "1rem",
    fontWeight: "Light",
    minWidth: "70px",
  },
  minMax: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  max: {
    color: "#666666",
    fontSize: "16px",
    marginBottom: "0px",
  },
  min: {
    color: "#666666",
    fontSize: "16px",
    marginTop: "0px",
  },
}));

export const ForecastTable = ({ dataPronostico }) => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const rowsPerPage = 1;

  const handlePrevPage = () => {
    setPage(page > 0 ? page - 1 : 0);
  };

  const handleNextPage = () => {
    setPage(
      page < dataPronostico.length - 1 ? page + 1 : dataPronostico.length - 1
    );
  };

  const isFirstPage = page === 0;
  const isLastPage = page === dataPronostico.length - 1;

  return (
    <div className={classes.containerComponentDescription}>
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell className={classes.tableCell}>Jornada</TableCell>
              <TableCell className={classes.tableCell}>Nubosidad</TableCell>
              <TableCell className={classes.tableCell}>Lluvia</TableCell>
              <TableCell className={classes.tableCell}>Viento</TableCell>
              <TableCell className={classes.tableCell}>Temperatura</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataPronostico
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((forecast, index) => (
                <React.Fragment key={index}>
                  <TableRow className={classes.forecastRow}>
                    <TableCell className={classes.dayColumn}>
                      Madrugada
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      
                        <GetWeatherIcon
                          iconoNubosidad={forecast.madrugada.iconoNubosidad}
                        />
                    </TableCell>
                    <TableCell className={classes.tableCell} >
                    
                        <GetRainIcon 
                          lluvia={forecast.madrugada.iconoLluvia}

                        />
                      
                    
                      </TableCell>
                    <TableCell className={classes.tableCell}>
                      {forecast.madrugada.viento}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <div className={classes.container}>
                        <div className={classes.temperatureBox}>
                          <div className={classes.current}>
                            {forecast.madrugada.temperatura.temperatura}
                          </div>
                          <div className={classes.minMax}>
                            <span className={classes.max}>
                              ↑ {forecast.madrugada.temperatura.temperaturaMax}
                            </span>
                            <span className={classes.min}>
                              ↓ {forecast.madrugada.temperatura.temperaturaMin}
                            </span>
                          </div>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow className={classes.forecastRow}>
                    <TableCell className={classes.dayColumn}>Mañana</TableCell>
                    <TableCell className={classes.tableCell}>
                      
                        <GetWeatherIcon
                          iconoNubosidad={forecast.mañana.iconoNubosidad}
                        />
                     
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                    
                        <GetRainIcon
                          lluvia={forecast.mañana.iconoLluvia}
                        />
                      
                      </TableCell>
                    <TableCell className={classes.tableCell}>
                      {forecast.mañana.viento}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <div className={classes.container}>
                        <div className={classes.temperatureBox}>
                          <div className={classes.current}>
                            {forecast.mañana.temperatura.temperatura}
                          </div>
                          <div className={classes.minMax}>
                            <span className={classes.max}>
                              ↑ {forecast.mañana.temperatura.temperaturaMax}
                            </span>
                            <span className={classes.min}>
                              ↓ {forecast.mañana.temperatura.temperaturaMin}
                            </span>
                          </div>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow className={classes.forecastRow}>
                    <TableCell className={classes.dayColumn}>Tarde</TableCell>
                    <TableCell className={classes.tableCell}>
                      
                        <GetWeatherIcon
                          iconoNubosidad={forecast.tarde.iconoNubosidad}
                        />
                     
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                    
                        <GetRainIcon
                          lluvia={forecast.tarde.iconoLluvia}
                        />
                      
                      </TableCell>
                    <TableCell className={classes.tableCell}>
                      {forecast.tarde.viento}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <div className={classes.container}>
                        <div className={classes.temperatureBox}>
                          <div className={classes.current}>
                            {forecast.tarde.temperatura.temperatura}
                          </div>
                          <div className={classes.minMax}>
                            <span className={classes.max}>
                              ↑ {forecast.tarde.temperatura.temperaturaMax}
                            </span>
                            <span className={classes.min}>
                              ↓ {forecast.tarde.temperatura.temperaturaMin}
                            </span>
                          </div>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow className={classes.forecastRow}>
                    <TableCell
                      className={classes.dayColumn}
                      style={{ borderBottom: "0.7px solid transparent" }}
                    >
                      Noche
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ borderBottom: "0.7px solid transparent" }}
                    >
                      
                        <GetWeatherIcon
                          iconoNubosidad={forecast.noche.iconoNubosidad}
                        />
                      
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ borderBottom: "0.7px solid transparent" }}
                    >
                      
                        <GetRainIcon
                          lluvia={forecast.noche.iconoLluvia}
                        />
                     
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ borderBottom: "1px solid transparent" }}
                    >
                      {forecast.noche.viento}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ borderBottom: "1px solid transparent" }}
                    >
                      <div className={classes.container}>
                        <div className={classes.temperatureBox}>
                          <div className={classes.current}>
                            {forecast.noche.temperatura.temperatura}
                          </div>
                          <div className={classes.minMax}>
                            <span className={classes.max}>
                              ↑ {forecast.noche.temperatura.temperaturaMax}
                            </span>
                            <span className={classes.min}>
                              ↓ {forecast.noche.temperatura.temperaturaMin}
                            </span>
                          </div>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div className={classes.pagination}>
        <div style={{ width: "90px", margin: "15px 0px" }}>
          <Typography align="center">{dataPronostico[page].dia}</Typography>
        </div>
        <div className={classes.arrowContainer}>
          <IconButton onClick={handlePrevPage} className={classes.arrowButton}>
            <ArrowBackIosRounded
              style={{ color: isFirstPage ? "gray" : COLORS_PROJECT.color_nav }}
            />
          </IconButton>
          <IconButton onClick={handleNextPage} className={classes.arrowButton}>
            <ArrowForwardIosRounded
              style={{ color: isLastPage ? "gray" : COLORS_PROJECT.color_nav }}
            />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

ForecastTable.propTypes = {
  dataPronostico: PropTypes.arrayOf(
    PropTypes.shape({
      dia: PropTypes.string.isRequired,
      madrugada: PropTypes.shape({
        nubosidad: PropTypes.string.isRequired,
        lluvia: PropTypes.string.isRequired,
        viento: PropTypes.string.isRequired,
        temperatura: PropTypes.shape({
          temperaturaNumber: PropTypes.string.isRequired,
          temperaturaMin: PropTypes.string.isRequired,
          temperaturaMax: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
      mañana: PropTypes.shape({
        nubosidad: PropTypes.string.isRequired,
        lluvia: PropTypes.string.isRequired,
        viento: PropTypes.string.isRequired,
        temperatura: PropTypes.shape({
          temperaturaNumber: PropTypes.string.isRequired,
          temperaturaMin: PropTypes.string.isRequired,
          temperaturaMax: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
      tarde: PropTypes.shape({
        nubosidad: PropTypes.string.isRequired,
        lluvia: PropTypes.string.isRequired,
        viento: PropTypes.string.isRequired,
        temperatura: PropTypes.shape({
          temperaturaNumber: PropTypes.string.isRequired,
          temperaturaMin: PropTypes.string.isRequired,
          temperaturaMax: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
      noche: PropTypes.shape({
        nubosidad: PropTypes.string.isRequired,
        lluvia: PropTypes.string.isRequired,
        viento: PropTypes.string.isRequired,
        temperatura: PropTypes.shape({
          temperaturaNumber: PropTypes.string.isRequired,
          temperaturaMin: PropTypes.string.isRequired,
          temperaturaMax: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    })
  ).isRequired,
};
